import { render, staticRenderFns } from "./TutorEventOrder.vue?vue&type=template&id=d525f836&scoped=true"
import script from "./TutorEventOrder.vue?vue&type=script&lang=js"
export * from "./TutorEventOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d525f836",
  null
  
)

export default component.exports